import React from 'react';
import { FaPhoneAlt, FaWhatsapp } from 'react-icons/fa';
import { COMPANY_INFO } from '../../constants';

function MobileCallBar() {
  return (
    <div className="lg:hidden fixed bottom-0 left-0 right-0 z-50 flex shadow-[0_-2px_10px_rgba(0,0,0,0.15)]">
      <a
        href={`tel:${COMPANY_INFO.phone}`}
        className="flex-1 flex items-center justify-center gap-2 bg-blue-700 text-white py-3.5 font-bold text-sm active:bg-blue-800"
        aria-label="Llamar ahora a Geriatría Serena"
      >
        <FaPhoneAlt /> Llamar ahora
      </a>
      <a
        href={`https://wa.me/${COMPANY_INFO.whatsapp}`}
        target="_blank"
        rel="noopener noreferrer"
        className="flex-1 flex items-center justify-center gap-2 bg-green-600 text-white py-3.5 font-bold text-sm active:bg-green-700"
        aria-label="Escribir por WhatsApp a Geriatría Serena"
      >
        <FaWhatsapp /> WhatsApp
      </a>
    </div>
  );
}

export default MobileCallBar;
